import React, { useState } from 'react';
import { SmartphoneIcon, TabletIcon, MonitorIcon } from 'lucide-react';
interface EmailPreviewProps {
  subject: string;
  html: string;
}
export function EmailPreview({
  subject,
  html
}: EmailPreviewProps) {
  const [device, setDevice] = useState<'mobile' | 'tablet' | 'desktop'>('desktop');
  const getDeviceWidth = () => {
    switch (device) {
      case 'mobile':
        return '375px';
      case 'tablet':
        return '768px';
      case 'desktop':
        return '100%';
    }
  };
  return <div className="space-y-4" data-id="element-1752" data-mp="ln9zg0azf3i1">
      <div className="flex items-center justify-between bg-white p-2 rounded-lg border border-gray-200" data-id="element-1753" data-mp="lk4bwpi049of">
        <div className="flex items-center gap-1 bg-gray-100 p-1 rounded-md" data-id="element-1754" data-mp="goysbxc2n73i">
          <button onClick={() => setDevice('mobile')} className={`p-1.5 rounded transition-colors ${device === 'mobile' ? 'bg-white shadow-sm text-blue-600' : 'text-gray-500 hover:text-gray-700'}`} title="Mobile view (375px)" data-id="element-1755" data-mp="bnja0d1a3eot">
            <SmartphoneIcon className="h-4 w-4" data-id="element-1756" data-mp="2fccirxujwe1p" />
          </button>
          <button onClick={() => setDevice('tablet')} className={`p-1.5 rounded transition-colors ${device === 'tablet' ? 'bg-white shadow-sm text-blue-600' : 'text-gray-500 hover:text-gray-700'}`} title="Tablet view (768px)" data-id="element-1757" data-mp="2jcmk2x7eega8">
            <TabletIcon className="h-4 w-4" data-id="element-1758" data-mp="2ae16zhkp3tgu" />
          </button>
          <button onClick={() => setDevice('desktop')} className={`p-1.5 rounded transition-colors ${device === 'desktop' ? 'bg-white shadow-sm text-blue-600' : 'text-gray-500 hover:text-gray-700'}`} title="Desktop view (100%)" data-id="element-1759" data-mp="1vmijkypiawng">
            <MonitorIcon className="h-4 w-4" data-id="element-1760" data-mp="1rkxbdqnx36jl" />
          </button>
        </div>
      </div>

      <div className="bg-gray-50 p-4 rounded-md border border-gray-200" data-id="element-1761" data-mp="1cnxvzgmtq9ek">
        <span className="text-sm font-medium text-gray-500" data-id="element-1762" data-mp="1cqshlbhkq09k">Subject:</span>
        <span className="ml-2 text-sm text-gray-900 font-medium" data-id="element-1763" data-mp="1hmr8b5qdjud5">
          {subject}
        </span>
      </div>

      <div className="w-full bg-gray-100 rounded border border-gray-200 overflow-hidden flex justify-center py-4 min-h-[500px]" data-id="element-1764" data-mp="yl0g0nocci2u">
        <div className="bg-white shadow-sm transition-all duration-300 ease-in-out h-full overflow-y-auto" style={{
        width: getDeviceWidth(),
        minHeight: '500px'
      }} data-id="element-1765" data-mp="osl1k0c96bmp">
          <div className="bg-gray-100 px-4 py-2 border-b border-gray-200 text-xs text-gray-500 uppercase tracking-wide" data-id="element-1766" data-mp="1hggvixaftpfs">
            Email Body Preview
          </div>
          <div className="p-8 bg-white min-h-[400px] prose max-w-none" dangerouslySetInnerHTML={{
          __html: html
        }} data-id="element-1767" data-mp="17jca4zof1y01" />
        </div>
      </div>
    </div>;
}